import React from "react";
import { useNavigate } from "react-router-dom";
import { Clock, Bot, ShieldCheck, Workflow, Lightbulb } from "lucide-react";
import AppHeader from "./components/AppHeader";

const Mission = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-secondary">
      {/* Header */}
      <AppHeader titleSize="text-5xl" />

      {/* Mission Banner */}
      <div className="bg-gradient-to-br from-accent to-secondary text-center py-20 px-6 md:px-12 shadow-inner">
  <div className="max-w-4xl mx-auto">
    <p className="text-3xl md:text-4xl font-medium text-primary leading-relaxed font-serif opacity-0 animate-[fadeIn_1s_ease-out_forwards]" style={{ animationDelay: '0.2s' }}>
      Reimagining academic assessment with a tool that is intuitive, adaptive, and focused on what educators need most
    </p>
  </div>
</div>

      {/* Our Vision and What Drives Us */}
      <div className="px-4 md:px-16 pt-12 pb-16 bg-secondary flex justify-center">
        <div className="bg-white shadow-lg rounded-xl p-8 w-full">
          {/* Our Vision */}
          <div className="bg-accent/20 rounded-lg p-5 shadow-sm mb-10 text-center">
            <h3 className="text-3xl font-bold text-primary mb-4">
              <Lightbulb className="inline-block mr-2 h-6 w-6 align-[-2px]" />
              Our Vision
            </h3>
            <p className="text-lg text-gray-700 max-w-4xl mx-auto">
              We aim to shape a world where technology amplifies educators’ impact — not by replacing their role,
              but by giving them the freedom to focus on what matters most: creating better learning experiences
            </p>
          </div>

          <h3 className="text-3xl font-bold text-gray-900 mb-6 text-center">Motivation</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-accent/20 rounded-lg p-5 shadow-sm">
              <h4 className="text-xl font-semibold text-primary mb-2">
                <Clock className="inline-block mr-2 h-5 w-5" />
                Less Time, More Engagement
              </h4>
              <p className="text-gray-700 text-base">
                We believe educators should spend less time formatting and more time engaging with students
              </p>
            </div>
            <div className="bg-accent/20 rounded-lg p-5 shadow-sm">
              <h4 className="text-xl font-semibold text-primary mb-2">
                <Bot className="inline-block mr-2 h-5 w-5" />
                Assistive Human-Centred AI
              </h4>
              <p className="text-gray-700 text-base">
                We use AI to support — not replace — educators, enhancing their work without removing their voice
              </p>
            </div>
            <div className="bg-accent/20 rounded-lg p-5 shadow-sm">
              <h4 className="text-xl font-semibold text-primary mb-2">
                <ShieldCheck className="inline-block mr-2 h-5 w-5" />
                Transparency & Trust
              </h4>
              <p className="text-gray-700 text-base">
                We value transparency, usability, and clarity — so you’re always in control of your content
              </p>
            </div>
            <div className="bg-accent/20 rounded-lg p-5 shadow-sm">
              <h4 className="text-xl font-semibold text-primary mb-2">
                <Workflow className="inline-block mr-2 h-5 w-5" />
                Streamlined Workflows
              </h4>
              <p className="text-gray-700 text-base">
                Our tools simplify academic tasks with intuitive, efficient design — no tech background needed. Decrease student incentive to cheat.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mission;
